import api from '../../../src/services/feApi.ts';
import { ApiResponse } from "../../types/ApiResponse";

import {
  TabsDto,
  NewTabDto,
  TabGuestDto,
  AddTabLineDto,
  RemoveTabDto,
  RemoveTabLineDto,
} from "../../types/sale/tabData";

export const TabService = {

  // --------------------------------------------------------------
  // LIST ALL TABS
  // --------------------------------------------------------------
  getAllTabs: async (): Promise<TabsDto[]> => {
    try {
      const response = await api.get<ApiResponse<TabsDto[]>>("/Sales/list/tabs");
      const result = response.data;

      if (!result.Success || result.StatusCode !== 200) {
        console.warn("Failed to fetch tabs:", result.Errors || result.Messages);
        return [];
      }

      return result.Data ?? [];
    } catch (error) {
      console.error("Failed to fetch tabs", error);
      return [];
    }
  },

  // --------------------------------------------------------------
  // ADD TAB
  // --------------------------------------------------------------
  addTab: async (rec: NewTabDto): Promise<NewTabDto | null> => {
    try {
      const response = await api.post<ApiResponse<NewTabDto>>(
        "/Sales/add/tab",
        rec
      );

      const result = response.data;

      if (!result.Success || result.StatusCode !== 200) {
        console.warn("Failed to add tab:", result.Errors || result.Messages);
        return null;
      }

      return result.Data;
    } catch (error) {
      console.error("Failed to add tab", error);
      return null;
    }
  },

  // --------------------------------------------------------------
  // REMOVE TAB
  // --------------------------------------------------------------
  removeTab: async (rec: RemoveTabDto): Promise<boolean> => {
    try {
      const response = await api.post<ApiResponse<null>>(
        "/Sales/void/tab",
        rec
      );

      const result = response.data;

      return result.Success === true;
    } catch (error) {
      console.error("Failed to void tab", error);
      return false;
    }
  },

  // --------------------------------------------------------------
  // REMOVE TAB LINE
  // --------------------------------------------------------------
  removeTabLine: async (rec: RemoveTabLineDto): Promise<boolean> => {
    try {
      const response = await api.post<ApiResponse<null>>(
        "/Sales/void/tab/line",
        rec
      );

      const result = response.data;

      return result.Success === true;
    } catch (error) {
      console.error("Failed to void tab line", error);
      return false;
    }
  },

  // --------------------------------------------------------------
  // TAB GUESTS
  // --------------------------------------------------------------
  getTabGuest: async (id: number): Promise<TabGuestDto[]> => {
    try {
      const response = await api.post<ApiResponse<TabGuestDto[]>>(
        "/Sales/list/account/tab/guests",
        { FK_AccountID: id }
      );

      const result = response.data;

      if (!result.Success || result.StatusCode !== 200) {
        console.warn("Failed to fetch tab guests:", result.Errors || result.Messages);
        return [];
      }

      return result.Data ?? [];
    } catch (error) {
      console.error("Failed to fetch tab guests", error);
      return [];
    }
  },

  // --------------------------------------------------------------
  // ADD TAB LINES
  // --------------------------------------------------------------
  addTabLine: async (rec: AddTabLineDto[]): Promise<boolean> => {
    try {
      const response = await api.post<ApiResponse<null>>(
        "/Sales/add/tab/line",
        { Tablines: rec }
      );

      const result = response.data;

      return result.Success === true;
    } catch (error) {
      console.error("Failed to add tab lines", error);
      return false;
    }
  },

  // --------------------------------------------------------------
  // LIST TAB LINES BY TAB ID
  // --------------------------------------------------------------
  getTabLinesById: async (id: string): Promise<any[]> => {
    try {
      const response = await api.post<ApiResponse<any[]>>(
        "/Sales/list/tab/lines",
        { TabID: id }
      );

      const result = response.data;

      if (!result.Success || result.StatusCode !== 200) {
        console.warn("Failed to fetch tab lines:", result.Errors || result.Messages);
        return [];
      }

      return result.Data ?? [];
    } catch (error) {
      console.error("Failed to fetch tab lines", error);
      return [];
    }
  }
};
